export default __webpack_public_path__ + "locales/sk/InviteDialog.json?hash=649fa650919c4d5e2f491ae96690709c";